// extracted by mini-css-extract-plugin
module.exports = {"coupon_card":"RewardsCoupon_coupon_card__zslgY"};